export const ASSET_CATEGORY_VEHICLE_INFOGRAPHICS =
  'ASSET_CATEGORY_VEHICLE_INFOGRAPHICS';
